const saveFilter = ({ storageName, filters, setOpen, filterKeyList }) => {
  // Get user ID
  const userID = localStorage.getItem('userId');

  const updatedFilter = localStorage?.getItem(storageName)?.[userID] || {};

  filters?.forEach(group => {
    const key = group?.title?.value;
    if (!updatedFilter[key]) {
      updatedFilter[key] = {};
    }
    group.items.forEach(item => {
      updatedFilter[key][item.value] = item.isSelected;
    });
  });

  const existingFilter = JSON.parse(localStorage.getItem(storageName)) || {};

  const filteredData = Object.fromEntries(
    Object.entries(existingFilter).filter(
      ([key, value]) => ![...filterKeyList].includes(key),
    ),
  );

  // Set the filter to local storage
  localStorage.setItem(
    storageName,
    JSON.stringify({
      ...filteredData,
      [userID]: updatedFilter,
    }),
  );

  setOpen?.(prev => false);
};

export default saveFilter;
